// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/Services.tsx

import HeroBanner from "../components/HeroBanner.tsx";
import HeroParallax from "../components/HeroParallax.tsx";
import ShowcaseSimplified from "../components/ShowcaseSimplified.tsx";
import PartnerGrid from "../components/PartnerGrid.tsx";
import CareersBanner from "../components/CareersBanner.tsx";
import ESG from "../components/ContentCard.tsx";
import ContactPerson from "../components/ContactPerson.tsx";
import AnchorMenu from "../components/AnchorMenu.tsx";
import { useLanguage } from "../lang/index.lang.tsx";

const Services = () => {
  const { t } = useLanguage();

  return (
    <>

      <AnchorMenu
        title="Services"
        titleLink="#services"  // Verlinkt zu services-top
        items={[          
          { id: "1", label: t("services.heading.AllServices"), anchor: "AllServices" },
          { id: "2", label: t("navigation.career"), anchor: "Careers" },
          { id: "3", label: t("services.heading.partner"), anchor: "Partner" },   
          { id: "4", label: t("anchor.contactPersons"), anchor: "ContactPersons" },   
          { id: "5", label: t("home.esg.heading.subtitle"), anchor: "esg" },   
          
          
        ]}
      />

      <section id="Services">
      <HeroParallax        
        header={t("services.design-build.header")}
        welcome={t("services.heading.welcome")}
        title={t("services.heading.title_header")}
        description={t("services.heading.description")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-2214040032.jpg"
      />
    </section>


      {/* Service ShowcaseSimplified */}
      <section id="AllServices">
      <ShowcaseSimplified
        heading={{
          subtitle: t("services.heading.subtitle"),
          title: t("services.designBuild.header"),
          explore: t("services.explore"),          
        }}        
        items={[
          {
            id: 1,
            title: t("services.designBuild.title"),
            subtitle: t("services.designBuild.description.short"),
            description: t("services.designBuild.description.long"),
            link: "/services/design-build",
          },
          {
            id: 2,
            title: t("services.generalPlanning.title"),
            subtitle: t("services.generalPlanning.description.short"),
            description: t("services.generalPlanning.description.long"),
            link: "/services/general-planning",
          },
          {
            id: 3,
            title: t("services.construction.title"),
            subtitle: t("services.construction.description.short"),
            description: t("services.construction.description.long"),
            link: "/services/construction-services",
          },
          {
            id: 4,
            title: t("services.dueDiligence.title"),
            subtitle: t("services.dueDiligence.description.short"),
            description: t("services.dueDiligence.description.long"),
            link: "/services/due-diligence",
          },
          {
            id: 5,
            title: t("services.energyAdvisory.title"),
            subtitle: t("services.energyAdvisory.description.short"),
            description: t("services.energyAdvisory.description.long"),
            link: "/services/energy-advisory",
          },
          {
            id: 6,
            title: t("services.developmentStrategies.title"),
            subtitle: t("services.developmentStrategies.description.short"),
            description: t("services.developmentStrategies.description.long"),
            link: "/services/development-strategies",
          },
          {
            id: 7,
            title: t("services.fireProtection.title"),
            subtitle: t("services.fireProtection.description.short"),
            description: t("services.fireProtection.description.long"),
            link: "/services/fire-protection",
          },
        ]}        
        learnMoreText={t("services.learnMore")}
      />
      </section>

      {/* HeroBanner Section - Careers */}
      <section id="Careers">
      <CareersBanner
        image="/images/EST-6372937.jpg"
        title={t("home.heroBanner.title")}
        description={t("home.heroBanner.description")}
        buttonText={t("home.heroBanner.buttonText")}
        buttonLink="/careers"
      />
      </section>

      {/* Partner Grid */}
      <section id="Partner">
      <PartnerGrid />
      </section>

      
      <section id="ContactPersons">
      {/* Contact Persons - Nur IDs übergeben, Daten kommen aus employees.json + de.json */}
      <ContactPerson
        heading={{
          subtitle: t("services.heading.subtitle"),
          title: t("services.heading.contact-person"),
        }}
        employeeIds={["SR","AS"]}
      />
      </section>

      <section id="esg">
      <ESG
        heading={{          
          title: t("home.esg.heading.title"),    
          description: t("home.esg.heading.description"),       
        }}
        data={[
          {
            id: 1,
            title: t("home.esg.s.title"),
            description: t("home.esg.s.description"),
            image: "/images/EST-1385648186.jpg",
            category: t("home.esg.s.category"),
            buttonText: t("home.esg.s.buttonText"),
            buttonLink: "/about",
          },
          {
            id: 2,
            title: t("home.esg.e.title"),
            description: t("home.esg.e.description"),
            image: "/images/EST-599972772.jpg",
            category: t("home.esg.e.category"),
            buttonText: t("home.esg.e.buttonText"),
            buttonLink: "/about",
          },          
          {
            id: 3,
            title: t("home.esg.g.title"),
            description: t("home.esg.g.description"),
            image: "/images/EST-12499784456.jpg",
            category: t("home.esg.g.category"),
            buttonText: t("home.esg.g.buttonText"),
            buttonLink: "/about",
          },          
        ]}
      />
      </section>

      



    </>
  );
};

export default Services;